import {
  eventCardTimeFormat as timeFormat,
  eventCardEventTimeFormat as eventTimeFormat,
} from '../../configuration/configs.js'
import labels from '../../configuration/labels'

export function getFormattedEventTime(startDate, endDate) {
  const startTime = startDate?.format(timeFormat)
  const endTime = endDate?.format(timeFormat)

  switch (eventTimeFormat) {
    case 'From-StartTime':
      return startTime ? `${labels.eventCardsLabelFrom}: ${startTime}` : ''

    case 'StartTime-EndTime':
    default:
      if (startTime && endTime) return `${startTime} - ${endTime}`
      if (startTime) return startTime
      if (endTime) return endTime
      return ''
  }
}
